import { render, staticRenderFns } from "./TableCsv.vue?vue&type=template&id=bc72d108&scoped=true"
import script from "./TableCsv.vue?vue&type=script&lang=js"
export * from "./TableCsv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc72d108",
  null
  
)

export default component.exports